import { BREAKPOINT } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const AccountDetailsCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 8px;

  position: relative;
  margin-top: 24px;
  margin-bottom: 24px;

  padding: 88px 16px 8px 16px;

  box-shadow: 0px 0px 3px 0px rgb(0 0 0 / 15%);

  width: 232px;

  align-self: center;

  background-color: ${({ theme }) => theme.colors.WHITE};

  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    position: absolute;
    right: 16px;
    top: 16px;
    margin: 0;
  }

  @media screen and (min-width: ${BREAKPOINT.LG}px) {
    position: relative;
    right: unset;
    top: unset;
    width: 100%;
    flex-direction: row;
    padding: 8px 10px 8px 16px;
  }
`
